/**
 * The toast after a bulk Tag / Untag on Contacts or Companies (#804).
 *
 * The server adds and removes tags by identity, so re-adding a tag a record
 * already has — in any case or spacing — changes nothing. Its response says how
 * many records it found (`count`) and how many actually changed (`changed`); the
 * toast reports the change, not the selection, so "Tags added to 1 contacts" no
 * longer appears for a click that did nothing.
 *
 * `changed` is absent from an older backend: fall back to the old wording.
 * Returns `{ tone, message }`: `info` when nothing changed (or nothing selected was
 * found), else `success`.
 */
export function bulkTagMessage({ action, count, changed, noun }) {
    const adding = action !== 'remove';
    if (typeof changed !== 'number') {
        return { tone: 'success', message: `Tags ${adding ? 'added to' : 'removed from'} ${count} ${noun}` };
    }
    if (!Number(count)) {
        // Nothing selected was found (deleted meanwhile, or another org's ids).
        return { tone: 'info', message: `No change: none of the selected ${noun} were found` };
    }
    if (changed === 0) {
        return {
            tone: 'info',
            message: `No change: the selected ${noun} ${adding ? 'already have' : "don't have"} these tags`,
        };
    }
    const rest = (Number(count) || 0) - changed;
    const tail = rest > 0 ? ` (${rest} ${adding ? 'already had them' : "didn't have them"})` : '';
    return { tone: 'success', message: `Tags ${adding ? 'added to' : 'removed from'} ${changed} ${noun}${tail}` };
}

export default bulkTagMessage;
